import type { OrganizationDetailTabItem } from '../types';

const getOrganizationDetailTabs = (): OrganizationDetailTabItem[] => [
    { tab: 'services', label: 'Services' },
    { tab: 'subscription', label: 'Subscription' },
    { tab: 'costs', label: 'Costs' },
    { tab: 'workflows', label: 'Workflows' },
];

export default getOrganizationDetailTabs;
